export var KS = [
    // 0-16
    { KS: { '0': 175.58, '300': 210.24, '600': 122.94, '1200': 83.62 } },
    // 17-20
    { KS: { '0': 292.2, '300': 254.51, '600': 235.99, '1200': 179.55 } },
    // 21
    { KS: { '0': 425.94, '300': 391.61, '600': 367.77, '1200': 306.23 } },
    // 22
    { KS: { '0': 434.04, '300': 400, '600': 376.28, '1200': 314.01 } },
    // 23
    { KS: { '0': 441.77, '300': 407.89, '600': 384.35, '1200': 321.45 } },
    // 24
    { KS: { '0': 449.04, '300': 415.14, '600': 391.9, '1200': 328.45 } },
    // 25
    { KS: { '0': 456.28, '300': 422.62, '600': 399.37, '1200': 335.36 } },
    // 26
    { KS: { '0': 463.45, '300': 430.15, '600': 406.74, '1200': 342.15 } },
    // 27
    { KS: { '0': 470.71, '300': 437.87, '600': 414.18, '1200': 348.97 } },
    // 28
    { KS: { '0': 478.05, '300': 445.82, '600': 421.67, '1200': 355.85 } },
    // 29
    { KS: { '0': 485.73, '300': 454.23, '600': 429.47, '1200': 362.98 } },
    // 30
    { KS: { '0': 493.28, '300': 462.48, '600': 437.15, '1200': 370.03 } },
    // 31
    { KS: { '0': 500.8, '300': 470.69, '600': 444.77, '1200': 377.12 } },
    // 32
    { KS: { '0': 508.29, '300': 478.87, '600': 452.36, '1200': 384.24 } },
    // 33
    { KS: { '0': 515.93, '300': 487.21, '600': 460.09, '1200': 391.52 } },
    // 34
    { KS: { '0': 523.84, '300': 495.87, '600': 468.09, '1200': 399.06 } },
    // 35
    { KS: { '0': 532, '300': 504.78, '600': 476.34, '1200': 406.84 } },
    // 36
    { KS: { '0': 540.43, '300': 513.99, '600': 484.85, '1200': 414.9 } },
    // 37
    { KS: { '0': 549.27, '300': 523.66, '600': 493.78, '1200': 423.36 } },
    // 38
    { KS: { '0': 558.57, '300': 533.85, '600': 503.17, '1200': 432.24 } },
    // 39
    { KS: { '0': 568.36, '300': 544.59, '600': 513.07, '1200': 441.55 } },
    // 40
    { KS: { '0': 578.53, '300': 555.76, '600': 523.34, '1200': 451.25 } },
    // 41
    { KS: { '0': 588.98, '300': 567.23, '600': 533.92, '1200': 461.23 } },
    // 42
    { KS: { '0': 599.85, '300': 579.1, '600': 544.9, '1200': 471.62 } },
    // 43
    { KS: { '0': 611.1, '300': 591.34, '600': 556.27, '1200': 482.36 } },
    // 44
    { KS: { '0': 622.65, '300': 603.85, '600': 567.95, '1200': 493.39 } },
    // 45
    { KS: { '0': 634.65, '300': 616.76, '600': 580.07, '1200': 504.91 } },
    // 46
    { KS: { '0': 647.05, '300': 630.03, '600': 592.6, '1200': 516.87 } },
    // 47
    { KS: { '0': 659.86, '300': 643.63, '600': 605.54, '1200': 529.26 } },
    // 48
    { KS: { '0': 673.05, '300': 657.52, '600': 618.88, '1200': 542.08 } },
    // 49
    { KS: { '0': 686.62, '300': 671.71, '600': 632.59, '1200': 555.28 } },
    // 50
    { KS: { '0': 700.55, '300': 686.19, '600': 646.66, '1200': 568.86 } },
    // 51
    { KS: { '0': 714.77, '300': 700.95, '600': 661.04, '1200': 582.8 } },
    // 52
    { KS: { '0': 729.31, '300': 715.95, '600': 675.73, '1200': 597.08 } },
    // 53
    { KS: { '0': 744.11, '300': 731.18, '600': 690.69, '1200': 611.67 } },
    // 54
    { KS: { '0': 759.25, '300': 746.72, '600': 705.98, '1200': 626.62 } },
    // 55
    { KS: { '0': 774.54, '300': 762.36, '600': 721.43, '1200': 641.75 } },
    // 56
    { KS: { '0': 790.26, '300': 778.31, '600': 737.3, '1200': 657.31 } },
    // 57
    { KS: { '0': 806.09, '300': 794.35, '600': 753.3, '1200': 673.06 } },
    // 58
    { KS: { '0': 822.34, '300': 810.74, '600': 769.7, '1200': 689.23 } },
    // 59
    { KS: { '0': 838.74, '300': 827.23, '600': 786.26, '1200': 705.58 } },
    // 60
    { KS: { '0': 855.53, '300': 844.01, '600': 803.19, '1200': 722.36 } },
    // 61
    { KS: { '0': 872.48, '300': 860.95, '600': 820.3, '1200': 739.4 } },
    // 62
    { KS: { '0': 889.6, '300': 878.04, '600': 837.56, '1200': 756.69 } },
    // 63
    { KS: { '0': 906.96, '300': 895.32, '600': 855.07, '1200': 774.33 } },
    // 64
    { KS: { '0': 924.47, '300': 912.71, '600': 872.72, '1200': 792.18 } },
    // 65
    { KS: { '0': 940.73, '300': 928.81, '600': 889.16, '1200': 808.89 } },
    // 66
    { KS: { '0': 957.09, '300': 944.95, '600': 905.69, '1200': 825.71 } },
    // 67
    { KS: { '0': 973.52, '300': 961.05, '600': 922.29, '1200': 842.62 } },
    // 68
    { KS: { '0': 989.99, '300': 977.16, '600': 938.92, '1200': 859.61 } },
    // 69
    { KS: { '0': 1006.53, '300': 993.19, '600': 955.61, '1200': 876.65 } },
    // 70
    { KS: { '0': 1022.89, '300': 1009, '600': 972.13, '1200': 893.55 } },
];
